import React, { useState } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ButtonProps } from "antd/lib/button";
import AddImageMemory from "../../views/modals/AddImageMemory/AddImageMemory";
import {
  IImageMemory,
  IDocumentMemory,
  IAudioMemory,
  IStorieMemory,
} from "../../interfaces";

export type AddMemoryButtonProps = {
  label: React.ReactNode;
  initialValue?: IImageMemory | IDocumentMemory | IAudioMemory | IStorieMemory;
  memoryType: "image" | "document" | "audio" | "storie";
};

const AddMemoryButton: React.FC<ButtonProps & AddMemoryButtonProps> = (
  props
) => {
  const [modalVisible, setModalVisible] = useState(false);
  const {
    className,
    onClick,
    onTouchEnd,
    icon,
    label,
    initialValue,
    memoryType,
    ...rest
  } = props;

  switch (memoryType) {
    case "image":
      return (
        <div>
          <Button
            className={`${className} rounded-lg flex items-center`}
            icon={icon ?? <PlusOutlined />}
            onClick={(e) => {
              setModalVisible(true);
              if (onClick) onClick(e);
            }}
            onTouchEnd={(e) => {
              setModalVisible(true);
              if (onTouchEnd) onTouchEnd(e);
            }}
            {...rest}
          >
            {label}
          </Button>
          <AddImageMemory
            visible={modalVisible}
            initialValue={props.initialValue as IImageMemory}
            onSuccess={(image: IImageMemory) => {}}
            handleCancel={() => {
              setModalVisible(false);
            }}
          />
        </div>
      );

    default:
      return <></>;
  }
};

export default AddMemoryButton;
